import React, { useState } from 'react';
import ButtonPrimaryNew from '../../Button/ButtonPrimary/ButtonPrimaryNew';
import { buildIdentityProviderUrl, decodeJwt, getAuthToken, getExpiryDate } from 'utils/auth.util';
import classes from './RefreshAuthPrompt.module.css';
import { useInterval } from '../../../utils/Hooks/useInterval';
import { addMinutes, isAfter } from 'date-fns';
import { CLOSE_POPUP_WINDOW } from '../../../constants/auth';

export function RefreshAuthPrompt() {
  const [promptUserToRefreshSession, setPromptUserToRefreshSession] = useState(!sessionIsFresh());
  const [refreshInProgress, setRefreshInProgress] = useState(false);

  const refreshInProgressInterval = 200;
  const sessionIsFreshInterval = 1000 * 30;

  useInterval(() => {
    setPromptUserToRefreshSession(!sessionIsFresh());
  }, sessionIsFreshInterval);

  useInterval(
    () => {
      if (sessionIsFresh()) {
        setRefreshInProgress(false);
        setPromptUserToRefreshSession(false);
      }
    },
    refreshInProgress ? refreshInProgressInterval : null,
  );

  const onClick = () => {
    setRefreshInProgress(true);
    window.open(
      buildIdentityProviderUrl(CLOSE_POPUP_WINDOW),
      'popUpWindow',
      'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes',
    );
  };

  if (promptUserToRefreshSession) {
    return (
      <div className={classes.overlay}>
        <aside className={classes.modal} role="dialog">
          <h2 className={classes.heading}>Your session has expired</h2>
          <ButtonPrimaryNew onClick={onClick}>Refresh session</ButtonPrimaryNew>
        </aside>
      </div>
    );
  }

  return null;
}

function sessionIsFresh() {
  const token = getAuthToken();
  if (token) {
    const twoMinutesFromNow = addMinutes(new Date(), 2);
    const tokenExpiry = getExpiryDate(decodeJwt(token));

    if (isAfter(tokenExpiry, twoMinutesFromNow)) {
      return true;
    }
  }
  return false;
}
